import { useState, type FormEvent } from "react";
import { Link, useNavigate } from "react-router-dom";

const HERO_IMAGE =
  "https://readdy.ai/api/search-image?query=Abstract%20editorial%20collage%20of%20layered%20torn%20paper%20sheets%20with%20warm%20ochre%20and%20deep%20vermillion%20light%20bleeding%20through%20dark%20ink%20shadows%2C%20mysterious%20investigative%20atmosphere%2C%20cinematic%20gradient%2C%20textured%20paper%20grain%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=home-hero-01&orientation=landscape";

export default function HomeHero() {
  const [query, setQuery] = useState("");
  const navigate = useNavigate();

  const handleSearch = (event: FormEvent) => {
    event.preventDefault();
    const keyword = query.trim();
    navigate(keyword ? `/expose?q=${encodeURIComponent(keyword)}` : "/expose");
  };

  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0 h-full w-full">
        <img
          src={HERO_IMAGE}
          alt="层叠纸张与暖色光影构成的抽象背景，象征对真相的层层追查"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/90 via-foreground-950/70 to-foreground-950/35" />
      </div>

      <div className="relative mx-auto flex w-full max-w-content flex-col justify-center px-4 py-20 md:px-8 md:py-28 lg:min-h-[620px]">
        <p className="mb-5 inline-flex w-fit items-center gap-2 rounded-full border border-background-50/30 bg-background-950/20 px-4 py-1.5 text-xs tracking-[0.2em] text-background-100 backdrop-blur-sm">
          <span className="h-1.5 w-1.5 rounded-full bg-accent-400" aria-hidden="true" />
          公共利益爆料平台
        </p>

        <h1 className="max-w-3xl font-heading text-3xl font-bold leading-tight text-background-50 md:text-5xl md:leading-[1.2]">
          明察爆料：曝光骗局
          <span className="block text-accent-400">守护每一个普通人的钱袋子</span>
        </h1>

        <p className="mt-6 max-w-2xl text-sm leading-7 text-background-100 md:text-base md:leading-8">
          我们整理网友的真实踩坑经历，把诈骗套路、消费陷阱、行业乱象拆开讲清楚。只针对事件与手法，不涉及任何个人隐私，让你在遇到类似情况时能第一时间识别。
        </p>

        <form
          onSubmit={handleSearch}
          className="mt-8 flex w-full max-w-xl flex-col gap-3 sm:flex-row"
          role="search"
        >
          <div className="relative flex-1">
            <i
              className="ri-search-line pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-base text-foreground-500"
              aria-hidden="true"
            />
            <input
              type="search"
              value={query}
              onChange={(event) => setQuery(event.target.value)}
              placeholder="输入关键词，如刷单、预付卡、假客服"
              aria-label="搜索爆料案例"
              className="w-full rounded-md border border-background-300 bg-background-50/95 py-3 pl-11 pr-4 text-sm text-foreground-900 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400"
            />
          </div>
          <button
            type="submit"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            立即搜索
          </button>
        </form>

        <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
          <Link
            to="/expose"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
          >
            <i className="ri-list-check-2 text-base" aria-hidden="true" />
            浏览爆料广场
          </Link>
          <Link
            to="/guides"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md px-2 py-3 text-sm font-medium text-accent-300 transition-colors hover:text-accent-200"
          >
            查看防骗指南
            <i className="ri-arrow-right-line text-base" aria-hidden="true" />
          </Link>
        </div>
      </div>
    </section>
  );
}